import { render } from "./VisionButton.vue?vue&type=template&id=203b8ec3&scoped=true"
import script from "./VisionButton.vue?vue&type=script&lang=js"
export * from "./VisionButton.vue?vue&type=script&lang=js"

import "./VisionButton.vue?vue&type=style&index=0&id=203b8ec3&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203b8ec3"]])

export default __exports__